<template>
	<div class="uk-container">
		<h1>Allgemeine Geschäftsbedingungen</h1>

		<terms></terms>
	</div>
</template>

<script>
import Terms from './Terms.vue'

export default {
	name: 'AGB',
	components: { Terms }
}
</script>
